// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';

// IMPORT PROJECT REFERENCES
import { DeviceSections } from '../DeviceBrowser/DeviceSections';
import { DeviceRowType } from '../DeviceBrowser/DeviceRowType';
import { DeviceRow } from '../DeviceBrowser/DeviceRow';
import { DeviceSection } from '../DeviceBrowser/DeviceSection';

// COMPONENT
export class EventsPage extends Component {

    constructor(props) {
        super(props);
    }

    generateSections(device) {
        // We have to manually define how the sections are laid out.
        
        // 1. Device Info and Events.
        let sections = {};

        if (device.eventSummary != undefined) {
            let rows = {};

            device.eventSummary.map(event => {
                name = event.name.replace(/([A-Z])/g, ' $1').trim()
                let row = new DeviceRow(name, DeviceRowType.BASIC, event.count + " times", false);
                rows[row.uid] = row;
            })

            let section = new DeviceSection("Device Events", rows);
            sections[section.uid] = section;
        }
       
        return sections;
    }

    render() {
        return (
            <div>
                 <DeviceSections sections={this.generateSections(this.props.device)} />
            </div>
        );
    }
}
